import React, { Component } from 'react';

import { isEmpty } from "lodash";

import { normalizeStr } from '../../../utils/generalFuncs';
import InputText from '../../common/Form';
import Dialog from '../../common/Dialog';

class BanksForm extends Component {
    state = { 
        bank_name: this.props.bank ? this.props.bank.bank_name : "",
        bank_desc: this.props.bank ? this.props.bank.bank_desc : "",
        bank_accounting: this.props.bank ? this.props.bank.bank_accounting : "",
        bank_solde_2022: this.props.bank ? this.props.bank.bank_solde_2022 : "",
        // bank_accounting: this.props.bank ? this.props.bank.bank_accounting : "",
        // bank_accountingDisplay: this.props.bank && this.props.bank.bank_accounting ? {
        //     value: this.props.bank.bank_accounting, 
        //     label: `${this.props.CATEGORIES.CHILD[this.props.bank.bank_accounting].category_accounting_id} - ${this.props.CATEGORIES.CHILD[this.props.bank.bank_accounting].category_name}`
        // } : {value:"", label:""},
        errors:{
            bank_name: "",
            bank_accounting: "",
        }
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        this.setState({
            [name]: value
        })
    }
    // handleChangeSelect = (option, name) => {
    //     if(option){
    //         this.setState({
    //             [name]: option.value || "",
    //             [`${name}Display`]: option
    //         })
    //     } else {
    //         this.setState({
    //             [name]: "",
    //             [`${name}Display`]: {}
    //         })
    //     }
    // }
    validate = () => {
        let required = [
            "bank_name",
            "bank_accounting"
        ]
        
        let noError = true
        let errors = {}
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    nameExist = (name, id) => {
        const { BANKS } = this.props;
        let list = []
        list = Object.values(BANKS).filter(item =>  ( 
            (normalizeStr(item.bank_name) === normalizeStr(name) ) && 
            (item.bank_id !== id) 
        ) )
            
        console.log("Item exist",{list});
        return !isEmpty(list)
    }
    handleSubmit = async () => {
        if(this.validate()){
            let data = {}
            if (this.props.update) {
                data = Object.assign(data, this.props.bank)
            }
            
            data.bank_name = this.state.bank_name.toUpperCase()
            data.bank_desc = this.state.bank_desc
            data.bank_accounting = this.state.bank_accounting
            data.bank_solde_2022 = parseFloat(this.state.bank_solde_2022)


            console.log('====================================');
            console.log({data});
            console.log('====================================');
            // check if name exist
            if(this.nameExist(data.bank_name, data.bank_id) ){
                this.props.notif("error",`Ce compte existe déjà`)
                return
            }

            if(this.props.update){
                await this.props.updateBank(data)
            } else {
                await this.props.newBank(data)  
            }

            if(this.props.STATE.banks.error){
                console.log('====================================');
                console.log("ERROR", this.props.STATE.banks );
                console.log('====================================');
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.banks.error}`)
            } else{
                !this.props.update && this.props.notif("success","La banque a été créé avec succès")
                this.props.update && this.props.notif("success","La banque a été modifiée avec succès")
                this.props.handleClose()
            }

        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    
    render() {
        const { CATEGORIES } = this.props;
        return (
            <Dialog
                close={this.props.handleClose}
                title={`${this.props.update ? "Modifier la " : "Créer une nouvelle"} Banque`}
                disabledSubmit={this.props.STATE.banks.fetching}
                submitTitle={this.props.update ? "Modifier" : "Créer"}
                submitAction={this.handleSubmit}
                appBar
            >
                <InputText
                    required
                    name="bank_name" 
                    id="bank_name" 
                    value={this.state.bank_name} 
                    label="Nom" 
                    placeholder="Nom du compte" 
                    error={this.state.errors.bank_name}  
                    onChange={this.handleChange}/>
                <InputText
                    multiline
                    rows="6"
                    name="bank_desc" 
                    id="bank_desc" 
                    value={this.state.bank_desc} 
                    label="Description" 
                    placeholder="Description du compte" 
                    error={this.state.errors.bank_desc}  
                    onChange={this.handleChange}/>
                
                {/* <Creatable
                    label="Compte Comptable"
                    required
                    error={this.state.errors.bank_accounting}
                    id="bank_accounting"
                    options={Object.values(CATEGORIES.CHILD).map( item => ({
                        label: `${item.category_accounting_id} - ${item.category_name}`,
                        value: item.category_id
                    }))}
                    value={this.state.bank_accountingDisplay}
                    openPopUp={this.props.createNewCategory}
                    onChange={(option) => this.handleChangeSelect(option, "bank_accounting" )}
                /> */}
                
                <InputText
                    required
                    name="bank_accounting" 
                    id="bank_accounting" 
                    value={this.state.bank_accounting} 
                    label="Compte Comptable" 
                    error={this.state.errors.bank_accounting} 
                    onChange={this.handleChange}
                    placeholder="521..."
                />
                <InputText
                    name="bank_solde_2022" 
                    id="bank_solde_2022" 
                    type="number"
                    value={this.state.bank_solde_2022} 
                    label="Solde au 01/01/2022" 
                    error={this.state.errors.bank_solde_2022} 
                    onChange={this.handleChange}
                    placeholder="Solde de départ"
                />
            
            </Dialog>
        );
    }
}

export default BanksForm;